import * as React from 'react';
require('./style.scss');

interface IProps {
	buttonComponent: any;
	className?: string;
	stopPropagation?: boolean;
}

interface IState {
	open: boolean;
}

export class DropdownModal extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			open: false,
		};

		this.onDocumentClick = this.onDocumentClick.bind(this);
	}

	private onDocumentClick() {
		this.setState({ open: false });
		document.removeEventListener('click', this.onDocumentClick);
	}

	componentDidUpdate(_prevProps: Readonly<IProps>, prevState: Readonly<IState>): void {
		if (!prevState.open && this.state.open) document.addEventListener('click', this.onDocumentClick);
	}

	componentWillUnmount(): void {
		document.removeEventListener('click', this.onDocumentClick);
	}

	render(): React.ReactNode {
		return (
			<div
				className={`dropdownModalWrapper ${this.props.className}`}
				onClick={(ev) => {
					if (this.props.stopPropagation) {
						ev.stopPropagation();
						ev.preventDefault();
					}
					this.setState((state) => ({ open: !state.open }));
				}}
			>
				{this.props.buttonComponent}
				{this.state.open && (
					<div className="dropdownModalDarkWrapper">
						<div className="dropdownModal">{this.props.children}</div>
					</div>
				)}
			</div>
		);
	}
}
